// Constantes et formats partagés par les pages Portefeuilles Side-B (liste, détail, admin)

// Couleurs de la répartition : déclinaisons de la palette Side-B (vert, violet, orange) puis neutres
export const PORTFOLIO_COLORS = [
  "#00BF63", "#B175FF", "#F79837", "#8CE5BA", "#CBA3FF", "#FABC7D",
  "#1FD07A", "#9747FF", "#a1a1aa", "#52525b",
];
export const colorAt = (i) => PORTFOLIO_COLORS[i % PORTFOLIO_COLORS.length];

// Profils de risque proposés dans l'éditeur admin
export const RISK_PROFILES = [
  { id: "prudent", label: "Prudent" },
  { id: "equilibre", label: "Équilibré" },
  { id: "dynamique", label: "Dynamique" },
  { id: "offensif", label: "Offensif" },
];

// Types de mouvements (valeurs réelles du moteur), traduits
export const ACTION_META = {
  DEPOSIT: { label: "Dépôt", plural: "Dépôts", cls: "text-emerald-300 bg-emerald-500/10 border-emerald-500/30" },
  WITHDRAW: { label: "Retrait", plural: "Retraits", cls: "text-rose-400 bg-rose-500/10 border-rose-500/30" },
  SWAP: { label: "Échange", plural: "Échanges", cls: "text-orange-300 bg-orange-500/10 border-orange-500/30" },
};

export const ASSET_TYPE_LABEL = {
  crypto: "Crypto",
  stock: "Action",
  etf: "ETF",
  cash: "Liquidités",
  stablecoin: "Stablecoin",
  commodity: "Matière première",
};

export const TIER_LABEL = { free: "Gratuit", essentiel: "Essentiel", pro: "Pro", max: "Max" };

// ── Formats (français) ──
export function fmtPctFr(n, digits = 1) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const abs = Math.abs(n).toLocaleString("fr-FR", { minimumFractionDigits: digits, maximumFractionDigits: digits });
  return `${n >= 0 ? "+" : "−"}${abs} %`;
}
export function fmtNumFr(n, digits = 1) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return Number(n).toLocaleString("fr-FR", { minimumFractionDigits: digits, maximumFractionDigits: digits });
}
export function fmtIntFr(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return Math.round(n).toLocaleString("fr-FR");
}
export function fmtDateFr(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return d;
  }
}
export function fmtMonthFr(d) {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
  } catch {
    return d;
  }
}
